module.exports = __webpack_public_path__ + "static/bokor_logo-be2e1a93e6c3f1ebd065cd506f00a517.png";